import React, { useState } from 'react';
import { IoCloseSharp } from "react-icons/io5";
// import { AxiosInstance } from '../../../../common/Loader/axios.config';
import axios from 'axios';
import Swal from 'sweetalert2';
import ClipLoader from 'react-spinners/ClipLoader';
import { AxiosInstance } from '../../../../common/Loader/axios.config';

export default function AddEpgModal({ isOpen, onClose, project, fetchPrograms }) {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [loading, setLoading] = useState(false);

    // const AxiosInstance = axios.create({
    //     baseURL: 'https://dev.staticcomputersinc.com/kanemaonline',
    // });

    if (!isOpen) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();

        const body = {
            project_id: project,
            title,
            description,
            starttime: startTime,
            endtime: endTime
        };

        console.log("Create EPG Body", body);

        try {
            setLoading(true);
            const response = await AxiosInstance.post('/epg', body);

            console.log("Create EPG Response", response);

            if (response.data.status === "success") {
                Swal.fire({
                    icon: "success",
                    title: "EPG Created successfully! ",
                    text: `${title} has been created successfully!`,
                    showConfirmButton: false,
                    timer: 2000,
                });
                setLoading(false);
                fetchPrograms();
                onClose();
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Failed to create program",
                    text: `${response.data.message}`,
                    showConfirmButton: false,
                    timer: 2000,
                });
                setLoading(false);
            }
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Failed to create project",
                text: "An error occurred while creating the project.",
                showConfirmButton: false,
                timer: 2000,
            });
            setLoading(false);
            console.error('Network error:', error);
        }
    };

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75">
            <div className="bg-brand-background rounded-lg p-6 w-1/2">
                <div className='flex items-center justify-between'>
                    <h2 className="text-lg font-bold text-white">Add New Program</h2>
                    <button onClick={onClose} className="mt-4 bg-red-500 text-white rounded px-4 py-2">
                        <IoCloseSharp />
                    </button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label htmlFor="title" className="block text-sm font-medium text-gray-700">Title</label>
                        <input type="text" id="title" name="title" className="mt-1 p-2 border border-gray-300 rounded w-full bg-transparent"
                            value={title} onChange={(e) => setTitle(e.target.value)} />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="description" className="block text-sm font-medium text-gray-700">Description</label>
                        <textarea
                            id="description"
                            name="description"
                            className="mt-1 p-2 border border-white border-opacity-70 rounded w-full bg-transparent"
                            rows={2}
                            value={description} onChange={(e) => setDescription(e.target.value)}
                        />
                    </div>

                    <div className='w-full flex items-center gap-x-3'>
                        <div className="w-1/2 mb-4">
                            <label htmlFor="startTime" className="block text-sm font-medium text-gray-700">Start Time</label>
                            <input type="datetime-local" id="startTime" name="startTime" className="mt-1 p-2 border border-gray-300 rounded w-full bg-transparent"
                                value={startTime} onChange={(e) => setStartTime(e.target.value)} />
                        </div>
                        <div className="w-1/2 mb-4">
                            <label htmlFor="endTime" className="block text-sm font-medium text-gray-700">End Time</label>
                            <input type="datetime-local" id="endTime" name="endTime" className="mt-1 p-2 border border-gray-300 rounded w-full bg-transparent"
                                value={endTime} onChange={(e) => setEndTime(e.target.value)} />
                        </div>
                    </div>

                    <div className="flex justify-end">
                        <button type="submit" className="bg-primary text-white p-2 rounded">
                            {loading ? <ClipLoader size={20} color="#FFFFFF" /> : "Create"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}